(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zolara-bundle-picker"] && !Shopify.designMode) return;
  try {
    class ZolaraBundlePicker extends HTMLElement {
    constructor() {
      super();
      this.cards = [];
      this.cta = null;
      this.errorEl = null;
      this.submitting = false;
    }

    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-zbp-card]'));
      this.cta = this.querySelector('[data-zbp-submit]');
      this.errorEl = this.querySelector('[data-zbp-error]');

      if (!this.cards.some((c) => c.classList.contains('is-selected')) && this.cards.length) {
        this.cards[0].classList.add('is-selected');
        const radio = this.cards[0].querySelector('.zbp__radio');
        if (radio) radio.checked = true;
      }

      this.cards.forEach((card) => {
        const radio = card.querySelector('.zbp__radio');
        card.addEventListener('click', (e) => {
          if (e.target.tagName === 'A') return;
          this.selectCard(card);
        });
        if (radio) radio.addEventListener('change', () => this.selectCard(card));
      });

      if (this.cta) {
        this.cta.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSubmit();
        });
      }

    }

    selectCard(card) {
      this.cards.forEach((c) => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      const radio = card.querySelector('.zbp__radio');
      if (radio) radio.checked = true;
      this.clearError();
    }

    getSelectedCard() {
      return this.cards.find((c) => c.classList.contains('is-selected')) || this.cards[0];
    }

    buildAddPayload(card) {
      const mainId = card.dataset.variantId;
      if (!mainId) return null;
      return { items: [{ id: Number(mainId), quantity: 1 }] };
    }

    async handleSubmit() {
      if (this.submitting) return;
      const card = this.getSelectedCard();
      if (!card) {
        this.showError('Please select an option.');
        return;
      }

      const payload = this.buildAddPayload(card);
      if (!payload) {
        this.showError('This option is not available.');
        return;
      }

      this.setLoading(true);
      this.clearError();

      const root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : `${root}cart/add.js`;

      const drawerEl = this.findDrawer();
      const sectionsToRender = this.getSectionsToRender(drawerEl);
      const bodyPayload = Object.assign({}, payload);
      if (sectionsToRender.length) {
        bodyPayload.sections = sectionsToRender.map((s) => s.id);
        bodyPayload.sections_url = window.location.pathname;
      }

      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify(bodyPayload)
        });

        const parsed = await res.json();

        if (!res.ok || parsed.status) {
          const msg = (parsed && (parsed.description || parsed.message)) || 'Could not add to cart.';
          throw new Error(msg);
        }

        if (window.PUB_SUB_EVENTS && window.publish) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'zolara-bundle-picker', productVariantId: card.dataset.variantId, cartData: parsed }); }
          catch (_) {}
        }

        document.dispatchEvent(new CustomEvent('zolara-bundle-picker:added', {
          bubbles: true,
          detail: { variantId: card.dataset.variantId, cartData: parsed }
        }));

        await this.handlePostAdd(parsed, drawerEl, sectionsToRender);
      } catch (err) {
        this.showError(err.message || 'Could not add to cart.');
      } finally {
        this.setLoading(false);
      }
    }

    async handlePostAdd(parsedResponse, drawerEl, sectionsToRender) {
      const mode = this.dataset.postAdd;
      const root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

      if (mode === 'checkout') {
        window.location.href = `${root}checkout`;
        return;
      }
      if (mode === 'cart_page') {
        window.location.href = `${root}cart`;
        return;
      }

      const opened = this.openCartDrawer(parsedResponse, drawerEl, sectionsToRender);
      if (!opened) {
        window.location.href = `${root}cart`;
      }
    }

    findDrawer() {
      return document.querySelector('cart-drawer')
        || document.querySelector('cart-notification')
        || document.querySelector('#CartDrawer')
        || document.querySelector('[is="cart-drawer"]')
        || document.querySelector('.cart-drawer');
    }

    getSectionsToRender(drawerEl) {
      const sections = [];

      if (drawerEl && typeof drawerEl.getSectionsToRender === 'function') {
        try {
          const list = drawerEl.getSectionsToRender();
          if (Array.isArray(list) && list.length) return list;
        } catch (_) {}
      }

      const drawerSectionId = drawerEl ? (drawerEl.closest('.shopify-section') || {}).id : null;
      const normalizedId = drawerSectionId ? drawerSectionId.replace(/^shopify-section-/, '') : 'cart-drawer';

      sections.push({ id: normalizedId, selector: '#CartDrawer' });

      const iconBubble = document.getElementById('cart-icon-bubble');
      if (iconBubble) {
        sections.push({ id: 'cart-icon-bubble', selector: '#cart-icon-bubble' });
      }

      return sections;
    }

    openCartDrawer(parsedResponse, drawerEl, sectionsToRender) {
      if (!drawerEl) return false;

      try {
        if (parsedResponse && parsedResponse.sections) {
          this.renderSectionsManually(parsedResponse.sections, sectionsToRender);
        }

        drawerEl.classList.remove('is-empty');

        if (typeof drawerEl.open === 'function') {
          try { drawerEl.open(); return true; } catch (_) {}
        }

        drawerEl.classList.add('active', 'animate', 'is-open');
        drawerEl.removeAttribute('hidden');
        drawerEl.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');

        const trigger = document.querySelector('[aria-controls="CartDrawer"], .header__icon--cart, a[href$="/cart"]');
        if (trigger) { trigger.click(); }

        return true;
      } catch (_) {
        return false;
      }
    }

    renderSectionsManually(sectionsHtml, sectionsToRender) {
      if (!sectionsHtml) return;
      sectionsToRender.forEach((section) => {
        const html = sectionsHtml[section.id];
        if (!html) return;
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!target) return;
        try {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const src = section.selector ? doc.querySelector(section.selector) : doc.getElementById(section.id);
          if (src) {
            target.innerHTML = src.innerHTML;
          } else {
            target.innerHTML = html;
          }

          const pageDrawer = document.querySelector('cart-drawer');
          const newDrawer = doc.querySelector('cart-drawer');
          if (pageDrawer && newDrawer) {
            pageDrawer.className = newDrawer.className;
            pageDrawer.classList.remove('is-empty');
          }

          const pageNotif = document.querySelector('cart-notification');
          const newNotif = doc.querySelector('cart-notification');
          if (pageNotif && newNotif) {
            pageNotif.className = newNotif.className;
          }
        } catch (_) {
          target.innerHTML = html;
        }
      });
    }

    setLoading(on) {
      this.submitting = on;
      if (!this.cta) return;
      this.cta.disabled = on;
      this.cta.classList.toggle('is-loading', on);
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

  }

  if (!customElements.get('zolara-bundle-picker')) {
    customElements.define('zolara-bundle-picker', ZolaraBundlePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
